import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
	root: {
		"& .ag-icon-menu": {
			display: "none",
		},
		"& .ag-header-cell-label": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: "0.85rem",
		},
		"& .ag-header-cell-text": {
			textAlign: "center !important",
		},
		"& .ag-cell": {
			alignItems: "center",
			padding: "0 10px !important",
			border: "unset !important",
		},
		"& .ag-header-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			fontSize: 10,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		"& .ag-menu-option": {
			cursor: "pointer",
		},
	},
	relative: {
		position: "relative",
	},
	textfield: {
		margin: theme.spacing(2),
	},
	btnModal: {
		display: "flex",
		justifyContent: "flex-end",
	},
}));
